import { FETCH_MOVIES, FETCH_ONE_MOVIE } from "../actions/actionType";

const initialState = {
  movies: [],
  movie: {},
};

function movieReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MOVIES:
      return {
        ...state,
        movies: action.payload,
      };
    case FETCH_ONE_MOVIE:
      return {
        ...state,
        movie: action.payload,
      };
    default:
      return state;
  }
}

export default movieReducer;
